import type React from "react";
import type { DetailedHTMLProps } from "react";
import { type Gap, tw } from "../../styling";
import { Stack } from "../stack";
import { Text } from "../typography";

type Props = DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {
	disabled?: boolean;
	error?: boolean;
	label?: string | React.ReactNode | undefined;
	children: React.ReactNode;
	gap?: Gap;
};

const labelClasses = tw`has-focus-visible:outline-interactive-primary inline-flex cursor-pointer self-start has-focus-visible:rounded-sm has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-solid`;

export const FormControlLabel: React.FC<Props> = ({
	label,
	children,
	gap = 2,
	disabled,
	error,
	...rest
}) => (
	<div className="flex">
		<label className={tw(labelClasses, disabled && "cursor-not-allowed")} {...rest}>
			<Stack direction="row" gap={gap}>
				{children}
				{label ? (
					<Text
						className={
							error ? "text-text-error" : disabled ? "text-text-disabled" : "text-text-primary"
						}
					>
						{label}
					</Text>
				) : null}
			</Stack>
		</label>
	</div>
);
